import "./listSolved.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import DatatableSolve from "../../components/datatableTicketSolve/DatatableSolve";

const ListSolved = ({columns}) => {
  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        <DatatableSolve columns={columns}/>
      </div>
    </div>
  )
}

export default ListSolved
